/* global REMOTE_PAGE_URL */
require('../polyfills/classList.js');

const Fields = require('../fields.js');

/* Constructor */

function View() {
  const self = this;

  self.$iFrame = {};
  self.$iFrame[Fields.CARD_NUMBER] = null;
  self.$iFrame[Fields.CVV] = null;
  self.$iFrame[Fields.EXPIRY] = null;

  self.iFrameLoaded = {};
  self.iFrameLoaded[Fields.CARD_NUMBER] = false;
  self.iFrameLoaded[Fields.CVV] = false;
  self.iFrameLoaded[Fields.EXPIRY] = false;

  self.parentOf = {};
  self.parentOf[Fields.CARD_NUMBER] = null;
  self.parentOf[Fields.CVV] = null;
  self.parentOf[Fields.EXPIRY] = null;
}

View.prototype.isSupportedBrowser = function() {
  return true; // TODO: Decide what features are needed, use Modernizr to detect
};

/* Render methods */

/* Called by the controller with `view.render('method-name', arg);` */

View.prototype._updateIFrame = function(data) {
  const self = this;
  const iframe = self.$iFrame[data.type];

  if (iframe) {
    iframe.height = data.inputHeight;
  }
};

View.prototype._addClass = function(data) {
  const self = this;
  const parent = self.parentOf[data.field];
  if (parent) {
    parent.classList.add(data.class);
  } else {
    self._error('Parent element does not exist');
  }
};

View.prototype._removeClass = function(data) {
  const self = this;
  const parent = self.parentOf[data.field];
  if (parent) {
    parent.classList.remove(data.class);
  } else {
    self._error('Parent element does not exist');
  }
};

View.prototype._create = function(type) {

  if (!window.location.origin) { // .origin not supported in ie < 11
    window.location.origin = `${window.location.protocol}//${window.location.hostname}`;
    if (window.location.port) {
      window.location.origin += `:${window.location.port}`;
    }
  }

  var iframe = document.createElement('iframe');
  iframe.src = `${REMOTE_PAGE_URL}?type=${type}&source=${encodeURIComponent(window.location.href)}&origin=${encodeURIComponent(window.location.origin)}`;
  iframe.scrolling = 'no';
  iframe.height = '0';
  iframe.width = '100%';
  iframe.name = `bambora-${type}-iframe`;
  iframe.style.border = 'none';
  iframe.style.overflow = 'visible';
  iframe.style.backgroundColor = 'transparent';
  iframe.allowTransparency = 'true';

  this.$iFrame[type] = iframe;
};

View.prototype._mount = function(data) {
  const self = this;
  var parent = document.querySelector(data.parent);
  const iframe = this.$iFrame[data.type];

  if (parent) {
    parent.appendChild(iframe);
    self.parentOf[data.type] = parent;
  } else {
    self._error(data.errorMsg);
  }
};

View.prototype._unmount = function(data) {
  const self = this;
  var parent = self.parentOf[data.type];

  if (parent) {
    parent.removeChild(parent.firstChild);
    self.parentOf[data.type] = null;
  } else {
    self._error(data.errorMsg);
  }
};

View.prototype._error = function(str) {
  console.error(`Custom Checkout: ${str}`);
};

/* Render handler */

View.prototype.render = function(viewCmd, parameter) {
  const self = this;
  var viewCommands = {
    updateIFrame: function() {
      self._updateIFrame(parameter);
    },
    addClass: function() {
      self._addClass(parameter);
    },
    removeClass: function() {
      self._removeClass(parameter);
    },
    create: function() {
      self._create(parameter);
    },
    mount: function() {
      self._mount(parameter);
    },
    unmount: function() {
      self._unmount(parameter);
    },
    error: function() {
      self._error(parameter);
    },
  };

  viewCommands[viewCmd]();
};

/* Message passing to iFrames */

// Send a message to the specified iFrame. If the iframe has been loaded,
// send message immediately, otherwise, add message to queue of messages in the
// iframe's onload event.
View.prototype.postMessage = function(msg, field) {
  const self = this;
  var iFrameSrc = REMOTE_PAGE_URL; // defined in webpack config

  if (self.$iFrame[field] === null && field === Fields.CVV) {
    return; // cvv field is optional, no need to send message

  } else if (self.$iFrame[field] === null) {
    self._error('Card number and expiry fields are required');

  } else if (self.iFrameLoaded[field]) {
    try {
      self.$iFrame[field].contentWindow.postMessage(JSON.stringify(msg), iFrameSrc);
    } catch (e) {
      self.render('error', `The ${field} field has not been mounted to the page`);
    }
  } else {
    var queuedMessages = self.$iFrame[field].onload;
    msg = JSON.stringify(msg);
    self.$iFrame[field].onload = function() {
      if(queuedMessages) {
        queuedMessages();
      }
      self.$iFrame[field].contentWindow.postMessage(msg, iFrameSrc);
      self.iFrameLoaded[field] = true;
    };
  }
};

// Returns the parent DOM element found and setup during 'mount'.
View.prototype.getParent = function(type) {
  const self = this;
  var parent = self.parentOf[type];
  return parent;
};

/* callback binding */

View.prototype.bind = function(event, handler) {
  if (event === 'message') {
    window.addEventListener('message', handler, false);
  }
};

module.exports = View;



// WEBPACK FOOTER //
// ./app/main/view.js